<template>
    <div class="spinner">
        <div class="bounce1 loading-bg-88"></div>
        <div class="bounce2 loading-bg-88"></div>
        <div class="bounce3 loading-bg-88"></div>
    </div>
</template>

<script>
export default {
    name: '',
    data () {
      return {}
    },
}
</script>
<style lang="less" scoped>
.spinner {
  margin: 10px auto 0;
  // width: 70px;
  text-align: center;
}

.spinner > div {
    width: 8px;
    height: 8px;
    // background-color: #888C8E;
    border-radius: 100%;
    display: inline-block;
    margin-right: 2px;
    margin-left: 2px;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}
.spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}

.spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0) }
    40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% { 
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}
</style>
